import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import moment from 'moment'; //Both are required here
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useQueryParams from '../../context/useQueryParams';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const Pooling = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [editPoolingDetail, setEditPoolingDetail] = useState({});
    const [isPoolingClosed, setIsPoolingClosed] = useState(false);
    const api = useApi();
    const [auctionDetail, setAuctionDetail] = useState({});
    const [pooledLots, setPooledLots] = useState([]);
    const [warningMessage, setWarningMessage] = useState("");
    const [isAuctionScheduled, setIsAuctionScheduled] = useState(false);
    const { setParameters } = useQueryParams();

    const planterDealerRenderer = (props) => {
        const planterOrDealer = (props.value === 1 ? "Planter" : (props.value === 2 ? "Dealer" : props.value));

        return (
            <span>{planterOrDealer} </span>
        );
    };
    const lotNumberRenderer = (props) => {

        return (
            <span>R{props.value} </span>
        );
    };

    const linkRenderer = (props) => {
        //const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
              <span>
                <span role="button" className="custom-link" onClick={() => viewPoolingDetail(props.data.pooledLotId)}>
                    <button className="btn ripple btn-outline-primary btn-sm mb-b-4" type="button" >
                        View
                    </button>
                </span>
                <button className="ms-2 btn ripple btn-outline-primary pd-x-10  btn-sm" type="button" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>
                    <i class="ti ti-import "></i>
                </button>
            </span>
        );
    };

    const buttonRenderer = (props) => {
        //const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (

            <button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>
                            <i class="ti ti-import me-2"></i>
                        </button>
            //<span>
            //    <span role="button" className="custom-link" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>{cellValue}</span>
            //</span>
        );
    };

    const specialLotRenderer = (props) => {
        const isSpecialLot = (props.value === true ? "Yes" : (props.value === false ? "No" : props.value));

        return (
            <span>{isSpecialLot} </span>
        );
    };

    const columns = [
        { headerName: '', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 120, cellRenderer: linkRenderer },
        { headerName: 'System Lot No.', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 60 },
        { headerName: 'Pooled Lot No.', field: 'poolLotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 60, cellRenderer: lotNumberRenderer },
        { headerName: 'Planter/ Dealer', field: 'planterDealer', cellClass: 'text-center', width: 68, cellRenderer: planterDealerRenderer },
        { headerName: 'Planter Name', field: 'planterName', cellClass: '', width: 240 },
        { headerName: 'Planter Mobile Number', field: 'planterMobileNumber', width: 100 },
        { headerName: 'CRNO/ SBL No', field: 'crnosblNo', width: 'auto' },
        { headerName: 'Litre Weight (gm)', field: 'litreWeightGms', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'No. of Bags', field: 'bags', headerClass: 'text-center', cellClass: 'text-center', width: 48 },
        { headerName: 'Bag Weight (Kg)', field: 'bagWeight', headerClass: 'text-center', cellClass: 'text-center', width: 70 },
        { headerName: 'Qty (Kg)', field: 'quantityKg', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'Grade Type', field: 'gradeType', cellClass: 'text-center', width: 100 },
        { headerName: 'Grade', field: 'grade', cellClass: 'text-center', width: 90 },
        { headerName: 'Moisture Content (%)', field: 'moistureContent', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Immature Seeds (%)', field: 'immatureSeeds', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Size', field: 'size', cellClass: 'text-center', width: 90 },
        { headerName: 'Colour', field: 'colour', cellClass: 'text-center', width: 90 },
        { headerName: 'Rejection', field: 'rejection', cellClass: 'text-center', width: 90 },
        { headerName: 'Is Speical Lot', field: 'isSpecialLot', cellClass: 'text-center', width: 90, cellRenderer: specialLotRenderer },
        { headerName: 'Speical Lot Remark', field: 'specialLotRemark', cellClass: 'text-center', width: 150},
        { headerName: 'Start Price', field: 'auctionStartPriceRs', cellClass: 'text-center', width: 60 },
        { headerName: 'Res. Price', field: 'reservedPrice', cellClass: 'text-center', width: 60 },
        { headerName: 'Planter/Dealer Bank A/c No.', field: 'bankAcNo', cellClass: 'text-center', width: 160 },
        { headerName: 'IFSC Code', field: 'ifscCode', cellClass: 'text-center', width: 130 },
        { headerName: 'Crop Receipt Number', field: 'cropReceiptNumber', cellClass: 'text-center', width: 250 },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };


    const loadPooledLots = async () => {
        try {
            const pooling = await api.getPooledLots(0);
            
            if (pooling) {

                setParameters(prev => ({ ...prev, poolingCenterName: pooling.centerName }));
                setIsPoolingClosed(pooling.isPoolingClosed);

                if (pooling.auctionId > 0) {

                    setIsAuctionScheduled(true);
                    setPooledLots(pooling.lotDetail);

                    var anyClosedPooling = pooling.lotDetail?.findIndex(t => t.isPoolingClosed === true);
                    if (anyClosedPooling > -1)
                        setIsPoolingClosed(true);

                    const dealerQty = pooling.lotDetail?.filter(t => parseInt(t.planterDealer) === 2)
                        .reduce((sum, t) => sum + t.quantityKg, 0);

                    const totalQty = pooling.lotDetail?.reduce((sum, t) => sum + t.quantityKg, 0);


                    if (dealerQty > 0.25 * totalQty) {
                        setWarningMessage("Dealer lot quantity is greater than 25% limit of the total auction quantity.");
                    } else {
                        setWarningMessage(""); // Clear the warning message if the condition is not met
                    }

                    pooling.lotDetail = null;
                    setAuctionDetail(pooling);
                }
                else {
                    setIsAuctionScheduled(false);
                }
            }
            else {
                setIsPoolingClosed(true);
            }

            //if (pooling && lotData.length > 0 && lotData[0].pooledLotId === -1) {
            //    setIsAuctionScheduled(false);
            //}
            //else {
            //    setIsAuctionScheduled(true);
            //    setPooledLots(lotData);
            //    var anyClosedPooling = lotData?.findIndex(t => t.isPoolingClosed === true);
            //    if (anyClosedPooling > -1)
            //        setIsPoolingClosed(true);
            //}
        } catch (error) {
            alert('Unable to fetch pooled lot data.');
        }
    };

    useEffect(() => {
        loadPooledLots();
    }, []);


    const viewPoolingDetail = (pooledLotId) => {

        const auctionId = auctionDetail.auctionId;
        navigate(`/pooledLot/${pooledLotId}?a=${auctionId}`);
    };

    const closePooling = async () => {

        if (window.confirm('You won\'t be able to add new lots once you close the pooling. Are you sure you want to proceed?') === true) {
            await api.closePooling()
                .then((response) => {
                    if (response.success) {
                        loadPooledLots();
                        alert(response.message);
                    }
                    else
                        alert(response.message);
                })
                .catch((error) => {
                    console.error('Error closing pooling :', error);
                });
        }
    };

    const downloadCropReceipt = async (id) => {

        const receiptData = await api.getCropReceipt(id);
        let rows = [];
        if (receiptData.isProvisionalCropReceipt === true)
            rows.push([{ text: "PROVISIONAL CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);
        else
            rows.push([{ text: "CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);

        rows.push([{ text: "Receipt No. " + receiptData.cropReceiptNumber, border: [true, false, false, true] }, { text: "Receipt Date : " + moment(receiptData.poolingDate).format('DD-MMM-YYYY'), alignment: "right", border: [false, false, true, true] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "POOLING DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Name Of Planter / Dealer / Contact No : " }, { text: receiptData.planterName + " / " + receiptData.planterMobileNumber, bold: true }]);
        rows.push([{ text: "Pooling Centre : " }, { text: receiptData.centerName, bold: true }]);
        rows.push([{ text: "Date of Pooling : " }, { text: moment(receiptData.poolingDate).format('DD-MMM-YYYY'), bold: true }]);
        rows.push([{ text: "CRNO/SBL No : " }, { text: receiptData.crnosblNo, bold: true }]);
        rows.push([{ text: "Lot Number : " }, { text: receiptData.lotNumber, bold: true }]);
        rows.push([{ text: "Number of bags : " }, { text: receiptData.bags, bold: true }]);
        rows.push([{ text: "Net Weight : " }, { text: receiptData.quantityKg + " kg", bold: true }]);
        rows.push([{ text: "Litre weight : " }, { text: receiptData.litreWeightGms + " gram", bold: true }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "AUCTIONEER DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Auctioneer : " + receiptData.companyName, colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "License No : " + receiptData.licenceNumber }, { text: "GST No : " + receiptData.gstNumber }]);
        rows.push([{ text: "Auction No. : " + receiptData.auctionNo }, { text: "Auction Date : " + moment(receiptData.auctionDate).format('DD-MMM-YYYY') }]);
        rows.push([{ text: "Payment Due Date : 10 days from the date of auction." }, { text: "" }]); //+ moment(receiptData.paymentDueDate).format('DD-MMM-YYYY')
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "The Cardamom pooled with us will be sold through our auction subject to the terms and conditions of the Cardamom Auctioneer Licence issued by Spice Board. This Crop Receipt should be produced when claiming payment.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "Declaration : Sealed sample handed over to Planter / Dealer.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 30, 0, 30], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Customer Signature", alignment: "center", border: [true, false, false, false] }, { text: "Authorized Signatory", alignment: "center", border: [false, false, true, false] }]);
        rows.push([{ text: "Sample taken: 3 Kg\nIf the lot is sold : Payment will be made for : (" + receiptData.quantityKg + "kg - 150gm) = " + (receiptData.quantityKg - 0.15) + " Kg.\nIf the lot is withdrawn before bidding : Whole sample will be returned.\nIf the lot is withdrawn after bidding : Payment will be made for 3000 gm based on the average price of that auction or return the sample in the form of cardamom mixed with other samples.\nIf the lot is detected with artificial colour, 2900 gm sample will be returned.", fontSize: 10, margin: [0, 10, 0, 10], colSpan: 2, border: [true, false, true, true] }, { text: "" }]);
        rows.push([{ text: "Software by Boltware | www.boltware.in", fontSize: 6, margin: [0, 20, 0, 20], colSpan: 2, border: [false, false, false, false] }, { text: "" }]);


        let body = rows;
        const documentDefinition = {
            content: [
                {
                    style: 'tableExample2',
                    table: {
                        //widths: [222,222],
                        body: body
                    }, layout: {
                        paddingLeft: (i, node) => 5,
                        paddingRight: (i, node) => 5,
                        paddingTop: (i, node) => 5,
                        paddingBottom: (i, node) => 5
                    }
                },
            ],
            styles: {
                tableExample2: {
                    width: '100%',
                    fontSize: 10, // Set the font size for the table
                },
            }
        };
        let filename = "Crop-Receipt-" + receiptData.cropReceiptNumber + ".pdf"
        pdfMake.createPdf(documentDefinition).download(filename);
    }


    const editStatus = (pooledLot) => {
        setEditPoolingDetail(pooledLot);
    }

    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Pooled Lots</h2>
                        <small> <i><p className='m-0'>Upcoming Auction </p></i> </small> 
                        <h5><strong>{auctionDetail?.companyName}</strong> on <strong>{moment(auctionDetail?.auctionDate).format('DD-MMM-YYYY')}</strong> </h5>
                    </div>
                   
                        <div className="d-flex">
                        {isAuctionScheduled === true && isPoolingClosed === false ?
                            <div className="justify-content-center">
                                <button type="button" className="btn btn-primary my-2 mg-r-5" onClick={() => viewPoolingDetail(0)}>
                                    <i className="fe fe-edit me-2"></i> Add New Lot
                                </button>
                                {/*<button type="button" className="btn btn-success my-2 btn-icon-text" onClick={closePooling}>*/}
                                {/*    <i className="fe fe-edit me-2"></i> Close pooling*/}
                                {/*</button>*/}
                            </div> : isAuctionScheduled === true ?
                                <div><span style={{ fontSize: '13px' }} className="badge rounded-pill bg-danger p-2 mg-b-5">Pooling closed for this center. Lot addition not allowed.</span></div>
                                : null
                            }
                        </div>
                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">

                            {isAuctionScheduled === true ?
                                <div className="card-body">
                                <div className="d-flex justify-content-between">
                                    <cite className="text-muted mg-b-4">Click on View to view detail of the lot.<br></br> Click on download button to download the Crop Receipt.</cite>
                                        {warningMessage !== "" ? <div ><span style={{ fontSize: '13px' }} className="d-flex align-items-center badge rounded-pill bg-danger p-2 mg-b-5"><i class="fe fe-info white fs-5 me-2"></i> {warningMessage}</span></div> : null}
                                    </div>
                                    <div
                                        style={{ height: '80vh' }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >
                                        <AgGridReact gridOptions={gridOptions}
                                            rowData={pooledLots}
                                        /></div>
                                </div> :
                                <div className="card-body">
                                    <span style={{ fontSize: '13px' }} className="badge rounded-pill bg-danger p-2 mg-b-5">No auctions schedule available. </span>
                                    <h5 className="mg-t-6">Pooling is allowed only upto 2 days prior to schedule of the auction date. </h5>
                                    <p>Please contact your auctioneer or check again later.</p>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Pooling;